// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SystemPayload__text-c6f7ca {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle);
  color: var(--base-80);
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/components/GroupDescription/LastMessageDescription/SystemPayload/SystemPayload.styles.m.css"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,4CAAA;EACA,qBAAA;EACA,mBAAA;AACF","sourcesContent":[".text {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle);\n  color: var(--base-80);\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `SystemPayload__text-c6f7ca`
};
module.exports = ___CSS_LOADER_EXPORT___;
